<emoji-mart
  [showPreview]="false"
  [totalFrequentLines]="1"
  [i18n]="emojiListTranslate"
  [darkMode]="darkMode()"
  [enableSearch]="false"
  [backgroundImageFn]="emojiSheet"
  (emojiSelect)="onSelectEmoji($event)"
></emoji-mart>
